import { useParams } from 'react-router';
import ArticleDetail from '@components/pages/ArticleDetail';
import { STORIES, getStory } from '@/data/resources';

export default function Story() {
    const { slug } = useParams();
    const story = getStory(slug);

    return (
        <ArticleDetail
            item={story}
            related={STORIES.filter((s) => s.slug !== slug).slice(0, 4)}
            basePath="/resources/stories"
            backLabel="Back to Stories"
            relatedLabel="More Stories"
            kindLabel="story"
        />
    );
}
